import { extendTheme } from '@chakra-ui/react'

const customTheme = extendTheme({
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false
  },
  components: {
    Button: {
      baseStyle: {
        borderRadius: '4px'
      }
    },
    Image: {
      baseStyle: {
        borderRadius: '4px'
      }
    },
    Card: {
      baseStyle: {
        borderRadius: '4px'
      }
    },
    ModalContent: {
      baseStyle: {
        borderRadius: '4px'
      }
    },
    Input: {
      baseStyle: {
        field: {
          borderRadius: '4px',
          _disabled: {
            backgroundColor: 'custom.gray.700',
            color: 'custom.gray.400',
            opacity: 1,
            border: 'none'
          }
        }
      }
    }
  },
  textStyles: {
    h1: {
      fontSize: '3.5rem',
      fontWeight: 'bold',
      lineHeight: '120%',
      fontFamily: 'Open Sans'
    },
    h2: {
      fontSize: '3rem',
      fontWeight: 'bold',
      lineHeight: '120%',
      fontFamily: 'Open Sans'
    },
    h3: {
      fontSize: '2.5rem',
      fontWeight: 'bold',
      lineHeight: '120%',
      fontFamily: 'Open Sans'
    },
    sub1: {
      fontSize: '2.0rem',
      fontWeight: 'semibold',
      lineHeight: '120%',
      fontFamily: 'Open Sans'
    },
    sub2: {
      fontSize: '1.5rem',
      fontWeight: 'semibold',
      lineHeight: '120%',
      fontFamily: 'Open Sans'
    },
    textL: {
      fontSize: '1.125rem',
      lineHeight: '150%',
      fontFamily: 'Inter'
    },
    textM: {
      fontSize: '1rem',
      lineHeight: '150%',
      fontFamily: 'Inter'
    },
    textS: {
      fontSize: '0.875rem',
      lineHeight: '150%',
      fontFamily: 'Inter'
    },
    textXS: {
      fontSize: '0.75rem',
      lineHeight: '150%',
      fontFamily: 'Inter'
    }
  },
  size: {
    base: {
      borderRadius: '4px'
    }
  },
  colors: {
    custom: {
      aqua: {
        light: '#D9FFFA',
        default: '#2BBBB2',
        dark: '#2BBBB2'
      },
      blue: {
        lighter: '#D4ECFF',
        light: '#CCE8FF',
        default: '#2196F3',
        dark: '#0674CC',
        darker: '#077FDE'
      },
      yellow: {
        light: '#FFF1BF',
        default: '#F3C521',
        dark: '#CCA108'
      },
      red: {
        light: '#FFD9DB',
        default: '#D5474C',
        system: '#D5474C',
        dark: '#B73338'
      },
      orange: {
        light: '#FFEDD9',
        dark: '#DF8620'
      },
      green: {
        light: '#D9FFEB',
        dark: '#2BBB6E'
      },
      purple: {
        default: '#6750A3'
      },
      system: {
        success: '#00823D',
        warning: '#F6D523',
        error: '#FF3030',
        info: '#2196F3',
        'success-dark': '#00823D',
        'warning-dark': '#F6D523',
        'error-dark': '#FF3030',
        'success-light': '#D9FFEB',
        'warning-light': '#FFEDD9',
        'error-light': '#FFD9DB'
      },
      gray: {
        100: '#212529',
        200: '#343A40',
        300: '#495057',
        400: '#868E96',
        500: '#ADB5BD',
        600: '#DEE2E6',
        700: '#E9ECEF',
        800: '#F1F3F5',
        900: '#F5F5FF'
      }
    }
  }
})

export default customTheme
